module.exports = __webpack_public_path__ + "static/media/free-plan-icon.d8305ed5.png";